import { Switch, Route, Redirect } from 'react-router-dom';

import './index.scss';
import { delayImport } from 'utils';
import {
	ACCOUNT_URL, LOGIN_URL, REGISTER_URL, FORGOT_PASSWORD_URL, NOT_FOUND_URL,
} from 'actions';

const Login = delayImport(import('pages/Authentication/Login'));
const Register = delayImport(import('pages/Authentication/Register'));
const ForgotPassword = delayImport(import('pages/Authentication/ForgotPassword'));

const AuthenticationLayout = () => (
	<div className="spa__authentication-layout">
		<Switch>
			<Route path={ACCOUNT_URL} exact>
				<Redirect to={LOGIN_URL} />
			</Route>
			<Route path={LOGIN_URL} exact component={Login} />
			<Route path={REGISTER_URL} exact component={Register} />
			<Route path={FORGOT_PASSWORD_URL} exact component={ForgotPassword} />
			<Route path="*">
				<Redirect to={NOT_FOUND_URL} />
			</Route>
		</Switch>
	</div>
);

export default AuthenticationLayout;
